/**
 * Institution B2B feature flags.
 *
 * INSTITUTIONS_ENABLED — module active (routes, API, student subscription bypass).
 * INSTITUTIONS_PUBLIC — show marketing links and open signup flows to everyone.
 *
 * Dev preview: ENABLED=true, PUBLIC=false → admins only via /institutions (link in admin menu).
 * Launch: set INSTITUTIONS_PUBLIC=true.
 */
export const INSTITUTIONS_ENABLED = true;
export const INSTITUTIONS_PUBLIC = false;

/** Race Mode — timed field races + weekly leaderboard. */
export const RACE_ENABLED = true;

/** Marketing surfaces (landing nav, footer). */
export function institutionsMarketingVisible() {
  return INSTITUTIONS_ENABLED && INSTITUTIONS_PUBLIC;
}

/** Platform admin preview while module is not public. */
export function institutionsAdminPreview(isAdmin) {
  return INSTITUTIONS_ENABLED && !INSTITUTIONS_PUBLIC && isAdmin;
}
